import { Component, Input } from '@angular/core';
import { TimeOffRequestApprovalFlow } from '@app/models/time-off-v3/time-off-request-approval-flow.model';

@Component({
    selector: 'app-force-approval-step',
    templateUrl: './force-approval-step.template.html',
    styleUrls: ['../approval-flows.style.scss'],
})
export class ForceApprovalStepComponent {
    @Input() approvalFlow: TimeOffRequestApprovalFlow;

    forceApprovedDenied(): string {
        return this.approvalFlow.forcedStatus === 'approved'
            ? 'time-off-v3.forcedApproved'
            : 'time-off-v3.forcedDenied';
    }
}
